import React from 'react'
import '../styles/Servicios/LogisticsServices.css'
//Images-Icons
import delivery from '../assets/vectores/delivery.png'
import almacenar from '../assets/vectores/almacenar.png'
import soporte from '../assets/vectores/soporte.png'

import { useTranslation } from 'react-i18next';


function LogisticsServices() {
  const {t} = useTranslation();

  return (
    <section>
      <h3 className='logistics'>{t("logistics")}</h3>
      <div className='logistics-container'>
        <div className='logistics-sevices-first'>
          <div className='logisticsIcons-container'>
            <img src={delivery} alt="logisticsIcons" className='logisticsIcons'/>
          </div>
          <div className='logistics-text'>
            <p>
              <h4>{t("logistics_1")}</h4>
              <br />
              {t("logistics_1_1")}
              <br />
              {t("logistics_1_2")}
              <br />
              {t("logistics_1_3")}
              <br />
              <br />
              {t("logistics_1_4")}
            </p>
          </div>
        </div>
        <hr className='sep'></hr>
        <div className='logistics-sevices-second'>
          <div className='logisticsIcons-container'>
            <img src={almacenar} alt="logisticsIcons" className='logisticsIcons'/>
          </div>
          <div className='logistics-text'>
            <p>
            <h4>{t("logistics_2_title")}</h4>
            {t("logistics_2")}
            </p>
          </div>
        </div>
        <hr className='sep'></hr>
        <div className='logistics-sevices-first'>
          <div className='logisticsIcons-container'>
            <img src={soporte} alt="logisticsIcons" className='logisticsIcons'/>
          </div>
          <div className='logistics-text'>
            <p>
              <h4>{t("logistics_3_title")}</h4>
              {t("logistics_3")}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LogisticsServices